import { FetchExperimentsRequestTypes } from '../actions/ExperimentationActions';
import { PENDING, SUCCEEDED } from '../actions/constants/RequestStatus';
import { makeRequestStatusSelector } from '../selectors/RequestStatusSelectors';
const fetchExperimentsStatus = makeRequestStatusSelector(FetchExperimentsRequestTypes.REQUEST);
export const getAreExperimentsLoading = state => {
  return fetchExperimentsStatus(state) === PENDING;
};
export const getHasExperimentsFetchSucceeded = state => {
  const requestStatus = fetchExperimentsStatus(state);
  return requestStatus === SUCCEEDED;
};
export const getExperimentByTreatmentKey = (state, treatmentKey) => {
  var _state$experimentatio;
  return (_state$experimentatio = state.experimentation.treatments) === null || _state$experimentatio === void 0 ? void 0 : _state$experimentatio[treatmentKey];
};
export const getEligiblePublicTreatments = state => state.experimentation.eligibleTreatments.filter(treatment => treatment.isPublic);
export const formatPublicExperimentationForQueryParams = treatments => {
  if (!(treatments !== null && treatments !== void 0 && treatments.length)) return undefined;
  const params = new URLSearchParams();
  treatments.forEach(treatment => {
    params.append('external-experiment-parameter', `${treatment.treatmentKey}-group-${treatment.group}`);
  });
  return params.toString();
};